export default {
  OPEN: "open",
  Rr: "purchase",
  vr: "push_click",
  pe: "custom_event",
  Qr: "iam_click",
  qs: "test"
};